export const HINT_TEXT =
  "Removes core words imported from CSV for the selected language, plus their sentences, translations, flashcards and sounds.";
